import { render } from "./ValidationStatusPill.vue?vue&type=template&id=6a652b58"
import script from "./ValidationStatusPill.vue?vue&type=script&lang=js"
export * from "./ValidationStatusPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__